import React, { Component } from 'react';
import './footer.css'

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <p>SQUADRA &copy; 2022</p>
        <h5>squadrastandupteam@gmail.com</h5>
        {/* <a className='follow-now-footer' href='https://facebook.com/squadrastandup' target="_blank">Follow Now</a> */}
        <a className='follow-now-footer' href='https://facebook.com/squadrastandup' target="_blank">Follow Now</a>
        <h5 className='by'>By <a target="_blank" href='https://www.linkedin.com/in/batoolal-ali/'>Batool Al-Ali</a> </h5>
      </footer>
    )
  }
}
